// File de synchronisation hors-ligne idempotente (quiz submits, etc.)
import api from "@/lib/api";

const KEY = "yaya_sync_queue";

const load = () => { try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; } };
const save = (q) => localStorage.setItem(KEY, JSON.stringify(q));

export const pendingCount = () => load().length;
export const isOnline = () => (typeof navigator === "undefined" ? true : navigator.onLine);

const uid = () =>
  (crypto && crypto.randomUUID ? crypto.randomUUID() : `evt_${Date.now()}_${Math.random().toString(16).slice(2)}`);

// Submit a quiz with offline support. Returns {result} online, or {queued:true} offline.
export async function submitQuiz(quizId, payload) {
  const event_id = uid();
  const body = { ...payload, event_id };
  if (!isOnline()) {
    const q = load();
    q.push({ type: "quiz_submit", quizId, body, ts: Date.now() });
    save(q);
    window.dispatchEvent(new Event("yaya-sync-change"));
    return { queued: true };
  }
  const { data } = await api.post(`/quizzes/${encodeURIComponent(quizId)}/submit`, body);
  return { result: data };
}

// Flush queued events; backend dedups by event_id (idempotent).
export async function flushQueue() {
  if (!isOnline()) return { flushed: 0 };
  let q = load();
  if (!q.length) return { flushed: 0 };
  let flushed = 0;
  const remaining = [];
  for (const item of q) {
    try {
      if (item.type === "quiz_submit") {
        await api.post(`/quizzes/${encodeURIComponent(item.quizId)}/submit`, item.body);
        flushed += 1;
      }
    } catch (e) {
      if (e.response && e.response.status >= 400 && e.response.status < 500) {
        flushed += 1; // client error / already processed -> drop
      } else {
        remaining.push(item); // network/5xx -> retry later
      }
    }
  }
  save(remaining);
  window.dispatchEvent(new Event("yaya-sync-change"));
  return { flushed };
}

if (typeof window !== "undefined") {
  window.addEventListener("online", () => { flushQueue(); });
}
